import { render, staticRenderFns } from "./SeatingInfo.vue?vue&type=template&id=79259c55&"
import script from "./SeatingInfo.vue?vue&type=script&lang=js&"
export * from "./SeatingInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports